import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { landingSchemas, pageHead } from "@/lib/seo";

const c = landingPages["fractional-cmo-b2b-saas"]!.en!;

export const Route = createFileRoute("/en/fractional-cmo-b2b-saas")({
  head: () =>
    pageHead({
      path: "/en/fractional-cmo-b2b-saas",
      title: c.title,
      description: c.description,
      crumbs: [["Fractional CMO B2B SaaS", "/en/fractional-cmo-b2b-saas"]],
      schemas: landingSchemas(c),
    }),
  component: () => <LandingPage pageKey="fractional-cmo-b2b-saas" forceLanguage="en" pathOverride="/en/fractional-cmo-b2b-saas" />,
});
